<template>
  <div class="reg-panel">
    <div class="panel-body">
      <div class="row g-3 align-items-start">
        <!-- Columna izquierda -->
        <div class="col-8">
          <!-- Indicador de trámite -->
          <div class="obs-box mb-3">
            <div class="d-flex align-items-center gap-2">
              <span class="material-symbols-outlined" style="font-size:18px;color:#0d6efd">receipt_long</span>
              <span class="field-label mb-0">Trámite:</span>
              <strong class="text-primary">{{ idTramite }}</strong>
            </div>
          </div>
          <!-- Búsqueda de elementos -->
          <div class="search-box">
            <div class="search-tabs">
              <button
                v-for="tab in tabs" :key="tab.key"
                class="search-tab"
                :class="{ active: tabActivo === tab.key }"
                @click="cambiarTab(tab.key)"
                type="button"
              >
                <span class="material-symbols-outlined" style="font-size:16px">{{ tab.icon }}</span>
                {{ tab.label }}
              </button>
            </div>
            <div class="d-flex gap-1 mt-1">
              <button type="button" class="btn-reload" @click="cargarElementos" title="Cargar elementos">
                <span class="material-symbols-outlined" style="font-size:18px">search</span>
              </button>
              <div style="position:relative; flex:1;">
                <input
                  type="text"
                  class="search-input"
                  v-model="filtro"
                  :placeholder="tabActual.placeholder"
                  :disabled="items.length === 0"
                  @input="filtrarItems"
                  @focus="mostrarDropdown = true"
                  @blur="ocultarConDelay"
                  autocomplete="off"
                />
                <div v-if="mostrarDropdown && itemsFiltrados.length > 0" class="search-dropdown">
                  <div
                    v-for="item in itemsFiltrados" :key="item.idElemento"
                    @mousedown="agregarElemento(item)"
                    class="dropdown-item-custom"
                    :class="{ selected: elementoYaSeleccionado(item.idElemento) }"
                  >
                    <span class="item-code">{{ item.elementoCodigo }}</span>
                    <span class="item-sep">—</span>
                    <span class="item-name">{{ item.elementoNombre }}</span>
                    <span v-if="elementoYaSeleccionado(item.idElemento)" class="item-check">
                      <span class="material-symbols-outlined" style="font-size:14px;color:#0d6efd">check</span>
                    </span>
                  </div>
                </div>
                <div
                  v-if="mostrarDropdown && filtro && itemsFiltrados.length === 0 && items.length > 0"
                  class="search-dropdown no-results"
                >
                  Sin resultados para "{{ filtro }}"
                </div>
              </div>
            </div>
            <div class="search-status mt-1">
              <span v-if="buscando" class="text-muted">
                <span class="material-symbols-outlined spin" style="font-size:14px">progress_activity</span>
                Cargando...
              </span>
              <span v-else-if="items.length === 0" class="text-muted">
                Sin elementos — presione 🔍 para cargar
              </span>
              <span v-else class="text-muted">{{ items.length }} elementos disponibles</span>
            </div>
          </div>
          <!-- Tabla de elementos seleccionados -->
          <div v-if="elementosSeleccionados.length" class="tabla-seleccionados mt-2">
            <div class="tabla-header" style="grid-template-columns: 90px 1fr 32px;">
              <span>Código</span>
              <span>Nombre</span>
              <span></span>
            </div>
            <div
              v-for="(item, idx) in elementosSeleccionados" :key="item.idElemento"
              class="tabla-row" style="grid-template-columns: 90px 1fr 32px;"
              :class="{ 'tabla-row-alt': idx % 2 === 1 }"
            >
              <span class="item-code">{{ item.elementoCodigo }}</span>
              <span class="item-name-sm">{{ item.elementoNombre }}</span>
              <button type="button" class="btn-remove" @click="quitarElemento(idx)" title="Quitar">
                <span class="material-symbols-outlined" style="font-size:16px">close</span>
              </button>
            </div>
          </div>
          <div v-else class="tabla-vacia mt-3">
            <span class="material-symbols-outlined" style="font-size:28px; color:#ced4da">receipt_long</span>
            <p class="mt-1 mb-0">Seleccione elementos para corregir</p>
          </div>
          <!-- Parámetros adicionales -->
          <div class="obs-box mt-3">
            <div class="row g-2">
              <div class="col-6">
                <label class="field-label">Cantidad</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  v-model.number="cantidad"
                  min="0"
                  step="0.01"
                  placeholder="1"
                />
              </div>
              <div class="col-6 d-flex flex-column justify-content-end">
                <div class="form-check form-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="switchSimular"
                    v-model="simular"
                  />
                  <label class="form-check-label field-label" for="switchSimular">
                    Modo simulación
                  </label>
                </div>
                <small class="text-muted" style="font-size:0.75rem">
                  {{ simular ? '⚠️ Los cambios NO se guardarán' : '✅ Los cambios se aplicarán' }}
                </small>
              </div>
            </div>
          </div>
        </div><!-- fin col-8 -->

        <!-- Columna derecha: acciones -->
        <div class="col-4 d-flex flex-column gap-3" style="padding-top:2rem;">
          <div v-if="elementosSeleccionados.length" class="resumen-box">
            <div class="resumen-row">
              <span>Trámite</span>
              <strong class="text-primary">{{ idTramite }}</strong>
            </div>
            <div class="resumen-row">
              <span>Elementos</span>
              <strong>{{ elementosSeleccionados.length }}</strong>
            </div>
            <div class="resumen-row">
              <span>Cantidad</span>
              <strong>{{ cantidad }}</strong>
            </div>
            <div class="resumen-row">
              <span>Modo</span>
              <strong :class="simular ? 'text-warning' : 'text-success'">
                {{ simular ? 'Simulación' : 'Real' }}
              </strong>
            </div>
          </div>
          <button
            type="button" class="btn-action primary"
            @click="ejecutar"
            :disabled="!puedeEjecutar"
            :title="simular ? 'Simular corrección' : 'Aplicar corrección'"
          >
            <span class="material-symbols-outlined">{{ simular ? 'labs' : 'build' }}</span>
            {{ simular ? 'Simular' : 'Ejecutar' }}
          </button>
          <button
            type="button" class="btn-action secondary"
            @click="limpiar"
            title="Limpiar todo"
          >
            <span class="material-symbols-outlined">delete</span>
            Limpiar
          </button>
        </div><!-- fin col-4 -->

      </div>
    </div>
  </div>
</template>

<script>
import api  from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "CorregirDiagCantidad",
  props: {
    idTramite:   { type: [Number, String], required: true },
    idPrestador: { type: [Number, String], required: true },
    idUsuario:   { type: [Number, String], required: true },
  },
  emits: ["ejecutado"],
  data() {
    return {
      // Elementos (tabs)
      tabActivo: "prestaciones",
      tabs: [
        { key: "prestaciones", label: "Prestaciones", icon: "medical_services", placeholder: "Buscar por código o nombre..." },
        { key: "medicamentos", label: "Medicamentos", icon: "medication",        placeholder: "Buscar medicamento..."         },
        { key: "insumos",      label: "Insumos",      icon: "inventory_2",       placeholder: "Buscar insumo..."              },
      ],
      items:                  [],
      itemsFiltrados:         [],
      filtro:                 "",
      buscando:               false,
      mostrarDropdown:        false,
      elementosSeleccionados: [],
      idPrestadorEfectivo:    null,
      // Parámetros
      cantidad: 1,
      simular:  true,
    };
  },
  computed: {
    tabActual() {
      return this.tabs.find(t => t.key === this.tabActivo) || this.tabs[0];
    },
    puedeEjecutar() {
      return (
        this.elementosSeleccionados.length > 0 &&
        this.cantidad !== null &&
        this.cantidad >= 0
      );
    },
  },
  async mounted() {
    try {
      const res = await api.get(`/vwprestadors/${this.idPrestador}`);
      this.idPrestadorEfectivo = res.data.idPrestadorPadre ?? this.idPrestador;
    } catch {
      this.idPrestadorEfectivo = this.idPrestador;
    }
  },
  methods: {
    cambiarTab(tab) {
      this.tabActivo      = tab;
      this.items          = [];
      this.itemsFiltrados = [];
      this.filtro         = "";
    },
    endpointPorTab() {
      const map = {
        prestaciones: `/vwtarifapress/idprestador/${this.idPrestadorEfectivo}`,
        medicamentos:  `/vwtarifapress/idprestador/10`,
        insumos:       `/vwtarifapress/idprestador/11`,
      };
      return map[this.tabActivo];
    },
    async cargarElementos() {
      this.buscando       = true;
      this.items          = [];
      this.itemsFiltrados = [];
      this.filtro         = "";
      try {
        const res  = await api.get(this.endpointPorTab());
        this.items = res.data;
      } catch {
        Swal.fire("Error", "No se pudo cargar los elementos", "error");
      } finally {
        this.buscando = false;
      }
    },
    filtrarItems() {
      this.mostrarDropdown = true;
      if (!this.filtro.trim()) { this.itemsFiltrados = []; return; }
      const f = this.filtro.toLowerCase();
      this.itemsFiltrados = this.items.filter(i =>
        (i.elementoCodigo ?? "").toLowerCase().includes(f) ||
        (i.elementoNombre ?? "").toLowerCase().includes(f)
      ).slice(0, 50);
    },
    ocultarConDelay() {
      setTimeout(() => { this.mostrarDropdown = false; }, 200);
    },
    elementoYaSeleccionado(idElemento) {
      return this.elementosSeleccionados.some(s => s.idElemento === idElemento);
    },
    agregarElemento(item) {
      if (this.elementoYaSeleccionado(item.idElemento)) return;
      this.elementosSeleccionados.push({ ...item });
      this.filtro          = "";
      this.itemsFiltrados  = [];
      this.mostrarDropdown = false;
    },
    quitarElemento(idx) {
      this.elementosSeleccionados.splice(idx, 1);
    },
    limpiar() {
      this.elementosSeleccionados = [];
      this.items                  = [];
      this.itemsFiltrados         = [];
      this.filtro                 = "";
      this.mostrarDropdown        = false;
      this.cantidad               = 1;
      this.simular                = true;
    },
    async ejecutar() {
      if (!this.puedeEjecutar) {
        Swal.fire("Atención", "Seleccione al menos un elemento", "warning");
        return;
      }
      const modoTexto = this.simular
        ? "simulación <strong>(sin guardar cambios)</strong>"
        : "modo <strong>REAL</strong> (los cambios se guardarán)";

      const confirm = await Swal.fire({
        title: "¿Confirmar ejecución?",
        html:  `Se ejecutará en ${modoTexto}.<br>
                <small class="text-muted">
                  Trámite ${this.idTramite} ·
                  ${this.elementosSeleccionados.length} elemento(s) ·
                  cantidad: ${this.cantidad}
                </small>`,
        icon:              this.simular ? "info" : "warning",
        showCancelButton:  true,
        confirmButtonText: this.simular ? "Sí, simular" : "Sí, ejecutar",
        cancelButtonText:  "Cancelar",
        confirmButtonColor: this.simular ? "#0d6efd" : "#dc3545",
      });
      if (!confirm.isConfirmed) return;

      try {
        const { data } = await api.get("/procedimientos/corregir-diag-cantidad", {
          params: {
            tramites: String(this.idTramite),   // ← directo de la prop
            codigos:  this.elementosSeleccionados.map(e => e.elementoCodigo).join(","),
            cantidad: this.cantidad,
            simular:  this.simular,
          },
        });
        const mensajesHtml = data.mensajes?.length
          ? `<pre style="text-align:left;font-size:0.75rem;max-height:300px;
                         overflow-y:auto;background:#f8f9fa;padding:10px;
                         border-radius:6px;">${data.mensajes.join("\n")}</pre>`
          : "";
        await Swal.fire({
          title: data.simular ? "Simulación completada" : "Éxito",
          html:  `<p>${data.simular ? "Sin cambios guardados. Impacto estimado:" : "Corrección aplicada correctamente."}</p>${mensajesHtml}`,
          icon:  data.simular ? "info" : "success",
          width: "700px",
        });
        if (!data.simular) {
          this.limpiar();
          this.$emit("ejecutado");
        }
      } catch (e) {
        const raw = e.response?.data;
        if (raw?.mensajes || raw?.simular !== undefined) {
          const mensajesHtml = raw.mensajes?.length
            ? `<pre style="text-align:left;font-size:0.75rem;max-height:300px;
                           overflow-y:auto;background:#f8f9fa;padding:10px;
                           border-radius:6px;">${raw.mensajes.join("\n")}</pre>`
            : "<p class='text-muted'>Sin detalle disponible</p>";
          await Swal.fire({
            title: "Simulación completada",
            html:  `<p>Sin cambios guardados. Impacto estimado:</p>${mensajesHtml}`,
            icon:  "info",
            width: "700px",
          });
          return;
        }
        const msg = typeof raw === "string"
          ? raw
          : raw?.message ?? raw?.error ?? e.message ?? "Error desconocido";
        Swal.fire("Error", msg, "error");
      }
    },
  },
};
</script>

<style scoped>
.reg-panel  { background: #f8f9fa; }
.panel-body { padding: 14px 16px; }
.search-tabs { display: flex; gap: 4px; border-bottom: 2px solid #dee2e6; margin-bottom: 6px; }
.search-tab {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 12px; border: none; background: transparent;
  font-size: 0.8rem; color: #6c757d; cursor: pointer;
  border-bottom: 2px solid transparent; margin-bottom: -2px;
  border-radius: 4px 4px 0 0; transition: all 0.15s;
}
.search-tab:hover  { background: #e8f0fe; color: #0d6efd; }
.search-tab.active { color: #0d6efd; border-bottom-color: #0d6efd; font-weight: 600; background: #fff; }
.search-input {
  width: 100%; padding: 6px 10px; border: 1px solid #ced4da;
  border-radius: 4px; font-size: 0.85rem; transition: border-color 0.15s;
}
.search-input:focus    { outline: none; border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,.15); }
.search-input:disabled { background: #f8f9fa; }
.btn-reload {
  display: flex; align-items: center; justify-content: center;
  padding: 6px 10px; border: 1px solid #ced4da; border-radius: 4px;
  background: #fff; cursor: pointer; color: #495057; transition: all 0.15s;
}
.btn-reload:hover { background: #0d6efd; color: #fff; border-color: #0d6efd; }
.search-dropdown {
  position: absolute; z-index: 1000; width: 100%;
  max-height: 260px; overflow-y: auto;
  background: #fff; border: 1px solid #ced4da;
  border-top: none; border-radius: 0 0 6px 6px;
  box-shadow: 0 6px 16px rgba(0,0,0,.12);
}
.dropdown-item-custom {
  display: flex; align-items: center; gap: 4px;
  padding: 7px 10px; cursor: pointer;
  border-bottom: 1px solid #f0f0f0; font-size: 0.82rem; transition: background 0.1s;
}
.dropdown-item-custom:hover,
.dropdown-item-custom.selected { background: #e8f0fe; }
.item-code    { font-weight: 700; color: #0d6efd; white-space: nowrap; }
.item-sep     { color: #adb5bd; margin: 0 2px; }
.item-name    { color: #343a40; flex: 1; }
.item-check   { margin-left: auto; }
.item-name-sm {
  color: #343a40; font-size: 0.8rem; flex: 1;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.no-results   { padding: 10px; font-size: 0.85rem; color: #6c757d; }
.search-status { font-size: 0.78rem; }
.obs-box {
  background: #fff; border: 1px solid #dee2e6;
  border-radius: 6px; padding: 10px 12px;
}
.tabla-seleccionados {
  border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden; font-size: 0.82rem;
}
.tabla-header {
  display: grid;
  background: #e9ecef; padding: 5px 8px; font-weight: 700; color: #495057; gap: 6px;
}
.tabla-row {
  display: grid;
  padding: 5px 8px; align-items: center; gap: 6px;
  border-top: 1px solid #f0f0f0; background: #fff;
}
.tabla-row-alt { background: #f8f9fa; }
.btn-remove {
  display: flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; border: 1px solid #bee5eb;
  border-radius: 4px; background: #f0f8ff; cursor: pointer;
  color: #0d6efd; transition: all 0.12s;
}
.btn-remove:hover { background: #0d6efd; color: #fff; border-color: #0d6efd; }
.tabla-vacia {
  display: flex; flex-direction: column; align-items: center;
  padding: 20px; color: #adb5bd; font-size: 0.85rem;
  border: 2px dashed #dee2e6; border-radius: 6px; background: #fff;
}
.resumen-box {
  background: #fff; border: 1px solid #dee2e6;
  border-radius: 6px; padding: 10px 12px; font-size: 0.82rem;
}
.resumen-row {
  display: flex; justify-content: space-between; padding: 2px 0; color: #495057;
}
.field-label { font-weight: 600; font-size: 0.85rem; color: #495057; display: block; margin-bottom: 4px; }
.btn-action {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px 14px; border: none; border-radius: 6px;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  transition: all 0.15s; width: 100%;
}
.btn-action.primary              { background: #0d6efd; color: #fff; }
.btn-action.primary:hover:not(:disabled) { background: #0b5ed7; }
.btn-action.secondary            { background: #fff; color: #6c757d; border: 1px solid #dee2e6; }
.btn-action.secondary:hover      { background: #f8f9fa; }
.btn-action:disabled             { opacity: 0.45; cursor: not-allowed; }
@keyframes spin { to { transform: rotate(360deg); } }
.spin { display: inline-block; animation: spin 1s linear infinite; }
</style>